export default function Approach() {
  const phases = [
    {
      title: "Discovery",
      image: "https://readdy.ai/api/search-image?query=Abstract%20soft%20pink%20geometric%20composition%20with%20centered%20circular%20forms%20and%20delicate%20overlapping%20translucent%20shapes%2C%20minimalist%20technological%20aesthetic%2C%20clean%20soft%20lighting%2C%20harmonious%20balanced%20composition%20with%20subtle%20depth%2C%20high%20detail%20editorial%20style%20without%20any%20text%20or%20human%20figures&width=600&height=500&seq=approach-discovery&orientation=portrait",
      bgColor: "bg-rose-100/60",
    },
    {
      title: "Architecture",
      image: "https://readdy.ai/api/search-image?query=Abstract%20mint%20green%20geometric%20composition%20with%20clean%20intersecting%20structural%20lines%20and%20layered%20transparent%20planes%2C%20architectural%20blueprint%20aesthetic%2C%20soft%20diffuse%20lighting%2C%20balanced%20symmetrical%20composition%20with%20depth%2C%20high%20detail%20editorial%20style%20without%20any%20text%20or%20human%20figures&width=600&height=500&seq=approach-architecture&orientation=portrait",
      bgColor: "bg-emerald-100/60",
    },
    {
      title: "Implementation",
      image: "https://readdy.ai/api/search-image?query=Abstract%20light%20gray%20geometric%20composition%20with%20precise%20angular%20forms%20and%20interconnected%20node%20patterns%2C%20systematic%20grid-inspired%20aesthetic%2C%20clean%20even%20lighting%2C%20organized%20structured%20composition%20with%20subtle%20depth%2C%20high%20detail%20editorial%20style%20without%20any%20text%20or%20human%20figures&width=600&height=500&seq=approach-implementation&orientation=portrait",
      bgColor: "bg-stone-100/60",
    },
    {
      title: "Evolution",
      image: "https://readdy.ai/api/search-image?query=Abstract%20warm%20yellow-brown%20geometric%20composition%20with%20flowing%20organic%20curves%20and%20ascending%20progressive%20shapes%2C%20evolutionary%20growth%20aesthetic%2C%20warm%20soft%20lighting%2C%20dynamic%20upward%20composition%20with%20depth%2C%20high%20detail%20editorial%20style%20without%20any%20text%20or%20human%20figures&width=600&height=500&seq=approach-evolution&orientation=portrait",
      bgColor: "bg-amber-100/60",
    },
  ];

  return (
    <section className="w-full py-16 md:py-24 lg:py-32 px-4 md:px-6 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <p className="text-xs md:text-sm tracking-wider uppercase text-secondary-600 font-medium mb-3 md:mb-4">
          Approach
        </p>
        <h2 className="font-heading text-2xl md:text-4xl lg:text-5xl font-bold text-foreground-950 leading-tight mb-3 md:mb-4">
          How We
          <br />
          <span className="font-light italic text-primary-600">Build Software</span>
        </h2>
        <p className="text-sm md:text-base text-foreground-600 max-w-xl mb-10 md:mb-16 leading-relaxed">
          Our engineering process follows a structured yet adaptable methodology that ensures
          quality at every stage, from initial concept through to long-term maintenance and evolution.
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {phases.map((phase) => (
            <div key={phase.title} className="rounded-xl overflow-hidden">
              <div className={`${phase.bgColor} h-48 md:h-56 lg:h-64 flex items-center justify-center p-4`}>
                <img
                  src={phase.image}
                  alt={`${phase.title} phase — abstract geometric composition`}
                  title={`${phase.title} — PROJEKTU REMAI, MB engineering approach`}
                  className="w-full h-full object-contain"
                />
              </div>
              <div className="bg-background-50 px-4 md:px-5 py-3 md:py-4">
                <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-950">
                  {phase.title}
                </h3>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}